<template>
  <div class="view view-offset view-about" v-html="content[language]" />
</template>

<script>
export default {
  name: 'view-about',
  props: {
    language: String
  },
  data: () => ({
    content: {
      de: '<h1>Optik Pillwein</h1><p>Individuelle Beratung für Ihre exquisiten Designerbrillen.</p><p>Topmodische Sonnenbrillen für Sommer und Winter.</p><p>Hochwertige Kontaktlinsen, von unseren Fachkräften angepasst.</p><p>Lesebrillen, Linsenpflegemittel und Accessoires für die ganze Familie.</p><h3>Wir freuen uns auf Ihren Besuch!</h3>',
      en: '<h1>Optik Pillwein</h1><p>Individual consultation for your exquisite designer glasses.</p><p>Top modern sunglasses for summer and winter.</p><p>High quality contact lenses, fitted by our trained staff.</p><p>Reading glasses, contact lens care products and accessories for the whole family.</p><h3>We look forward to your visit.</h3>'
    }
  }),
  computed: {
    mobile () { return this.$vuetify.breakpoint.smAndDown }
  }
}
</script>

<style lang="scss">
.view-about {
  text-align: center;
  padding: 18px;
}
</style>
